import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleButtonComponent } from './toggle-button.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [ToggleButtonComponent],
  imports: [CommonModule, PipesModule],
  exports: [ToggleButtonComponent],
})
export class ToggleButtonModule {}
